import { render, staticRenderFns } from "./PublicProductOverview.vue?vue&type=template&id=787a2448&scoped=true&"
import script from "./PublicProductOverview.vue?vue&type=script&lang=js&"
export * from "./PublicProductOverview.vue?vue&type=script&lang=js&"
import style0 from "./PublicProductOverview.vue?vue&type=style&index=0&id=787a2448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a2448",
  null
  
)

export default component.exports